import { FC, ReactNode } from 'react'

interface ReportShellProps {
  title: string
  description: string
  children: ReactNode
  filters?: ReactNode
  actions?: ReactNode
}

export const ReportShell: FC<ReportShellProps> = ({ title, description, children, filters, actions }) => {
  return (
    <div className='container-fluid py-4'>
      <div className='card border-0 shadow-sm mb-4'>
        <div className='card-body'>
          <div className='d-flex flex-column flex-lg-row justify-content-between gap-4 align-items-lg-center'>
            <div>
              <div className='text-uppercase text-muted fw-semibold fs-8 mb-2'>Relatórios do Vendedor</div>
              <h1 className='fs-2hx fw-bold text-dark mb-3'>{title}</h1>
              <p className='text-gray-600 fs-6 mb-0' style={{ maxWidth: '920px' }}>
                {description}
              </p>
            </div>
            {actions ? <div className='d-flex flex-column gap-2'>{actions}</div> : null}
          </div>
        </div>
      </div>

      {filters ? (
        <div className='card border-0 shadow-sm mb-4'>
          <div className='card-body'>{filters}</div>
        </div>
      ) : null}

      {children}
    </div>
  )
}